import React, { useState, useEffect } from "react";
import { IoIosArrowDown, IoIosArrowUp} from 'react-icons/io'

function About({ title, info }) {

    const [showInfo, setShowInfo] = useState(false)

    return (
        <div className="question">
            <header className="header" onClick={() => setShowInfo(!showInfo)}>
                <h4>{title}</h4>
                <button className="info-btn">
                    {showInfo ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </button>
            </header>
            {showInfo && <p>{info}</p>}
        </div>
    )
}

export default About


